import { FC, useEffect, useRef } from "react";
import ButtonComponent from "../../../../../common/components/button/button.component";
import CardComponent from "../../../../../common/components/card/card.component";
import FormFieldComponent from "../../../../../common/components/form/field/form-field.component";
import FormComponent from "../../../../../common/components/form/form.component";
import InputComponent from "../../../../../common/components/form/input/input.component";
import formValidationHelper from "../../../../../common/utils/validation/form-validation.helper";
import appTranslationsHelper from "../../../../../languages/app-translations.helper";
import { useSignUpPassengerContext } from "../common/context/sign-up-passenger.context";

const SignUpPassengerAccountComponent: FC = () => {
  const translations =
    appTranslationsHelper.getPassengerSignUpTranslations().accountDataForm;

  const {
    accountData,
    setAccountDataEmail,
    setAccountDataUsername,
    setAccountDataPassword,
    setAccountDataRepeatPassword,
    accountDataValidationResults,
    validateAccountDataEmail,
    validateAccountDataUsername,
    validateAccountDataPassword,
    validateAccountDataRepeatPassword,
    submitAccountStep,
    accountDataDisabledFormFields,
  } = useSignUpPassengerContext();

  const emailInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (emailInputRef.current && !accountData.email) {
      emailInputRef.current.focus();
    }
  }, [emailInputRef.current]);

  const isSubmitButtonEnabled = formValidationHelper.checkThatFormHasErrors(
    accountDataValidationResults
  );

  return (
    <div className="sign_up_passenger__account">
      <div className="sign_up_passenger__account_content">
        <h1 className="sign_up_passenger__step_title">{translations.title}</h1>
        <CardComponent>
          <FormComponent onSubmit={submitAccountStep}>
            <FormFieldComponent
              label={translations.emailLabel}
              isRequired
              classNames={{ root: "mt-0" }}
              errorMessage={accountDataValidationResults.email.errorMessage}
            >
              <InputComponent
                placeholder={translations.emailPlaceholder}
                value={accountData.email}
                onChange={setAccountDataEmail}
                onBlur={validateAccountDataEmail}
                hasError={!!accountDataValidationResults.email.errorMessage}
                inputRef={emailInputRef}
                isDisabled={accountDataDisabledFormFields.email}
                idForTesting={`account-data-email-input`}
              />
            </FormFieldComponent>
            <FormFieldComponent
              label={translations.usernameLabel}
              isRequired
              classNames={{ root: "mt-0" }}
              errorMessage={accountDataValidationResults.username.errorMessage}
            >
              <InputComponent
                placeholder={translations.usernamePlaceholder}
                value={accountData.username}
                onChange={setAccountDataUsername}
                onBlur={validateAccountDataUsername}
                hasError={!!accountDataValidationResults.username.errorMessage}
                isDisabled={accountDataDisabledFormFields.username}
                idForTesting={`account-data-username-input`}
              />
            </FormFieldComponent>
            <FormFieldComponent
              label={translations.passwordLabel}
              isRequired
              errorMessage={accountDataValidationResults.password.errorMessage}
            >
              <InputComponent
                placeholder={translations.passwordPlaceholder}
                value={accountData.password}
                onChange={setAccountDataPassword}
                onBlur={validateAccountDataPassword}
                hasError={!!accountDataValidationResults.password.errorMessage}
                type="password"
                idForTesting={`account-data-password-input`}
              />
            </FormFieldComponent>
            <FormFieldComponent
              label={translations.passwordRepeatLabel}
              isRequired
              errorMessage={
                accountDataValidationResults.repeatPassword.errorMessage
              }
            >
              <InputComponent
                placeholder={translations.passwordRepeatPlaceholder}
                value={accountData.repeatPassword}
                onChange={setAccountDataRepeatPassword}
                onBlur={validateAccountDataRepeatPassword}
                hasError={
                  !!accountDataValidationResults.repeatPassword.errorMessage
                }
                type="password"
                idForTesting={`account-data-password-repeat-input`}
              />
            </FormFieldComponent>
          </FormComponent>
        </CardComponent>
        <div className="sign_up_passenger__next_button_wrapper">
          <ButtonComponent
            onClick={submitAccountStep}
            type="primary"
            isDisabled={!isSubmitButtonEnabled}
            idForTesting={`account-data-submit-button`}
          >
            {translations.submitButtonText}
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
};

export default SignUpPassengerAccountComponent;
